/*
 *
 * OrderManagement Actions
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 11-Jun-2024
 */

import { createAction, createRequestTypes, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_ORDER_SEARCH: '@@OrderManagement/order_search',
  DO_FETCH_ORDER_DETAILS: '@@OrderManagement/fetch_order_details',
  DO_RESET_ORDER_MANAGEMENT: '@@OrderManagement/reset_order_management',
  DO_RESET_PAGINATION: '@@OrderManagement/reset_pagination',
  DO_EXPORT_ORDERS: '@@OrderManagement/export_orders',
  // @generator action:route:type
  ...createRequestTypes('@@OrderManagement', 'ORDER_RECOVERY'),
  ...createRequestTypes('@@OrderManagement', 'DO_GET_ORDER_DETAILS'),
  ...createRequestTypes('@@OrderManagement', 'RETRIVE_ORDERS_EXPORT_FILE')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name retriveOrdersExportFile
 * @return {object} - The action object
 */
export const retriveOrdersExportFile = new MakeRequest('OrderManagement', 'retrive_orders_export_file')
/** @action request
 * * Insert a description
 * @name doGetOrderDetails
 * @return {object} - The action object
 */
export const doGetOrderDetails = new MakeRequest('OrderManagement', 'do_get_order_details')
/** @action request
 * * Insert a description
 * @name orderRecovery
 * @return {object} - The action object
 */
export const orderRecovery = new MakeRequest('OrderManagement', 'order_recovery')
// @generator action:route
/** @action
 * * Insert a description
 * @name ExportOrders
 * @return {object} - The payload object
 */
export const doExportOrders = (payload) => createAction(actionTypes.DO_EXPORT_ORDERS, { payload })
/** @action
 * * Insert a description
 * @name ResetPagination
 * @return {object} - The payload object
 */
export const doResetPagination = (payload) => createAction(actionTypes.DO_RESET_PAGINATION, { payload })
/** @action
 * * Insert a description
 * @name ResetOrderManagement
 * @return {object} - The payload object
 */
export const doResetOrderManagement = () => createAction(actionTypes.DO_RESET_ORDER_MANAGEMENT)
/** @action
 * * Insert a description
 * @name FetchOrderDetails
 * @return {object} - The payload object
 */
export const doFetchOrderDetails = (payload) => createAction(actionTypes.DO_FETCH_ORDER_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name OrderSearch
 * @return {object} - The payload object
 */
export const doOrderSearch = (payload) => createAction(actionTypes.DO_ORDER_SEARCH, { payload })
